/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { displayMessage } from '@insticator/insticator-ui'; // iui-state
import { getDetailUniqueEngagedUsers, getDetailRevenueMetrics, updateDetailDateRange } from 'state/actions/detailViewState/detailViewStatus';
import { updataDetailDropDown, fetchCountries, fetchEmbeds, clearDetailState } from 'state/actions/detailViewState/detailViewStatus';
// component
import UniqueEngagedUsers from 'pages/dashboard/analytics/detail/metrics/uniqueengagedusers/uniqueengagedusers';



/* ========== ~~~~~~~~~~ DATA DETAIL METRIC : CONTAINER ~~~~~~~~~~ ========== */
const mapStateToProps = ({ detailViewStatus, sessionStatus, accountData }) => ({
    devices: detailViewStatus.devices,
    selectedDevices: detailViewStatus.selectedDevices,
    countries: detailViewStatus.countries,
    countriesReceived: detailViewStatus.countriesReceived,
    selectedCountries: detailViewStatus.selectedCountries,
    sites: accountData.sites,
    sitesReceived: accountData.sitesReceived,
    selectedSites: detailViewStatus.selectedSites,
    embeds: detailViewStatus.embeds,
    embedsReceived: detailViewStatus.embedsReceived,
    selectedEmbeds: detailViewStatus.selectedEmbeds,
    dateRange: detailViewStatus.dateRange,

    uniqueEngagedUsersDetail: detailViewStatus.uniqueEngagedUsersDetail,
    uniqueEngagedUsersDetailFetching: detailViewStatus.uniqueEngagedUsersDetailFetching,

    accountUUID: sessionStatus.accountUUID
    });

// map actions
const mapDispatchToProps = dispatch => ({
    displayMessage: message => dispatch(displayMessage(message)),
    updateDateRange: range => dispatch(updateDetailDateRange(range)),
    updateDetailDropDown: (items, itemType) => dispatch(updataDetailDropDown(items, itemType)),
    fetchCountries: (accountUUID, paramString) => dispatch(fetchCountries(accountUUID, paramString)),
    fetchEmbeds: (accountUUID) => dispatch(fetchEmbeds(accountUUID)),
    getDetailUniqueEngagedUsers: (paramString) => dispatch(getDetailUniqueEngagedUsers(paramString)),
    clearDetailState: () => dispatch(clearDetailState()),
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UniqueEngagedUsers);
